import { LockRecord } from '@/types/LockRecord';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface LockRecordsState {
  records: LockRecord[];
  unlockItem: LockRecord | null;
}

const initialState: LockRecordsState = {
  records: [],
  unlockItem: null,
}

export const LockSlice = createSlice({
  name: 'lockRecords',
  initialState,
  reducers: {
    setLockRecords: (state: LockRecordsState, action: PayloadAction<LockRecord[]>) => {
      state.records = action.payload;
    },
  }
});

export const { setLockRecords } = LockSlice.actions;
export default LockSlice;